let utils = require('../../../actions/utils');
let utilsSignals = require('../../../signals/utils');
let analytics = require('../../../actions/analytics');
let content = require('../../../actions/layout/content');
let account = require('../../../actions/account');
let orders = require('../../../actions/account/orders');
let ordersList = require('../../../actions/account/orders-list');
let computedOrdersList = require('../../../actions/computed/account/orders-list');
let userGroup = require('../../groups/user');
let layoutGroup = require('../../groups/layout');
let accountGroup = require('../../groups/account');
let { raiseEventsOnOrderLoaded } = require('../../groups/analytics');
let seo = require('../../../actions/seo');
let user = require('../../../actions/user');
let bitrix = require('../../../actions/bitrix');

let setDefaults = [
    utils.setPopupVisibility('ordersFilter', ['account', 'popups', 'ordersFilter', 'isOpen']),
    utils.set(['account', 'orders', 'ui', 'typeFilter', 'isDisabled'], false),
    ordersList.setPagingDefaultsIfNeeded,
    ordersList.setStateFormUrlClient
];

let setComputedForClient = [
    computedOrdersList.setOrdersFilters,
    computedOrdersList.setActiveOrdersFilter
];

let initPage = [
    utils.set('layout', 'main'),
    utils.setFromArgsToState('subPage', 'page.sub'),
    ...layoutGroup.setMainLayoutBlocks,
    seo.setDashboardMeta('Заказы - Библиотека данных', 'Мои заказы'),
    content.setComponentsByLink,
    ...setDefaults,
    account.setComputedFields,
    orders.setComputedFields,
    ordersList.setComputedFields,
    ...setComputedForClient,
    content.setIsLoading(true)
];

module.exports = [
    analytics.parseUtmFromQuery,
    orders.validateOrderId,
    ...userGroup.checkAuthCookie([
        ...userGroup.getUser
    ]),
    [
        user.isUnauthorized,
        {
            yes: [
                [
                    account.isShowLocalOrder,
                    {
                        yes: [
                            ...initPage,
                            ...accountGroup.setLocalOrderData
                        ],
                        no: [
                            utils.setArgToCookie('orderId', 10),
                            ...utilsSignals.redirectLogin
                        ]
                    }
                ]
            ],
            no: [
                ...userGroup.access('account', [
                    ...initPage,
                    ...accountGroup.updateOrderData,
                    content.setIsLoading(false),
                    analytics.pageview,
                    ...raiseEventsOnOrderLoaded
                ])
            ]
        }
    ]
];



// WEBPACK FOOTER //
// ./signals/pages/account/orders.js